/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type VimeoVideoStatus = "available" | "generic_error" | "not_found" | "not_found_error" | "quota_exceeded" | "transcode_starting" | "transcoding" | "transcoding_error" | "uploading" | "uploading_error" | "%future added value";
export type ProductSwiper_item = {
    readonly id: string;
    readonly reviews: {
        readonly videoReview: {
            readonly status: string | null;
        } | null;
    } | null;
    readonly carouselPhotos: ReadonlyArray<{
        readonly smallPath: string | null;
        readonly masterOrZoomPath: string | null;
        readonly " $fragmentRefs": FragmentRefs<"SwiperItem_photo">;
    } | null> | null;
    readonly video?: {
        readonly vimeoId: string | null;
        readonly status: VimeoVideoStatus | null;
        readonly " $fragmentRefs": FragmentRefs<"SwiperItem_video">;
    } | null | undefined;
    readonly viewInRoomPhotos: ReadonlyArray<{
        readonly " $fragmentRefs": FragmentRefs<"ViewInRoomImage_viewInRoomPhoto">;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"ViewInRoomImage_item">;
    readonly " $refType": "ProductSwiper_item";
};
export type ProductSwiper_item$data = ProductSwiper_item;
export type ProductSwiper_item$key = {
    readonly " $data"?: ProductSwiper_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ProductSwiper_item">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "fetchVideo"
    },
    {
      "defaultValue": 3,
      "kind": "LocalArgument",
      "name": "photosLimit"
    },
    {
      "defaultValue": 0,
      "kind": "LocalArgument",
      "name": "viewInRoomLimit"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductSwiper_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemReviewDocumentList",
      "kind": "LinkedField",
      "name": "reviews",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ItemReview",
          "kind": "LinkedField",
          "name": "videoReview",
          "plural": false,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": "carouselPhotos",
      "args": [
        {
          "kind": "Variable",
          "name": "limit",
          "variableName": "photosLimit"
        }
      ],
      "concreteType": "ItemPhoto",
      "kind": "LinkedField",
      "name": "photos",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "smallPath",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "masterOrZoomPath",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SwiperItem_photo"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "limit",
          "variableName": "viewInRoomLimit"
        }
      ],
      "concreteType": "viewInRoomPhotos",
      "kind": "LinkedField",
      "name": "viewInRoomPhotos",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ViewInRoomImage_viewInRoomPhoto"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ViewInRoomImage_item"
    },
    {
      "condition": "fetchVideo",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "video",
          "args": null,
          "concreteType": "VideoVimeo",
          "kind": "LinkedField",
          "name": "videoVimeo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "vimeoId",
              "storageKey": null
            },
            (v0/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SwiperItem_video"
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();
(node as any).hash = '4e72e7e00f89524cf985a66777337cd8';
export default node;
